import axios from 'axios'

export const getApiErrorMessage = (error: unknown): string | null => {
  if (!axios.isAxiosError(error)) return null
  const responseData = error.response?.data as
    | {
        error?: string
        message?: string
        errors?: Record<string, string[] | string>
      }
    | undefined

  if (typeof responseData?.error === 'string' && responseData.error.trim().length > 0) {
    return responseData.error
  }
  if (typeof responseData?.message === 'string' && responseData.message.trim().length > 0) {
    return responseData.message
  }
  if (responseData?.errors && typeof responseData.errors === 'object') {
    const firstKey = Object.keys(responseData.errors)[0]
    const firstValue = firstKey ? responseData.errors[firstKey] : null
    if (Array.isArray(firstValue) && firstValue.length > 0) {
      return firstValue[0]
    }
    if (typeof firstValue === 'string' && firstValue.trim().length > 0) {
      return firstValue
    }
  }

  return null
}
